<div class="vc-modal__innerContainer vc-modal__innerContainer--addPictures" [ngClass]="{hasLoader: loading}">
  <button aria-label="close modal" class="vc-modal__closeBtn" [mat-dialog-close]>
    <span class="vc-modal__closeBtn__crossLeft"></span> <span class="vc-modal__closeBtn__crossRight"></span>
  </button>

  <div class="vc-modal__title" i18n="@@PRODUCT.DETAILS.UPLOAD.TITLE">Add additional photos</div>

  <div class="vc-modal__content addPictures">
    <ng-container *ngIf="fileSent; else uploadForm">
      <p class="addPictures__instructions addPictures__instructions--success">
        <vc-sprite-icons name="checkmark" class="addPictures__instructions__checkIcon"></vc-sprite-icons>
        <ng-container i18n="@@PRODUCT.DETAILS.UPLOAD.MSG_SUCCESS">Your photo has been added successfully.</ng-container>
      </p>
    </ng-container>
    <ng-template #uploadForm>
      <p class="addPictures__instructions" i18n="@@PRODUCT.DETAILS.UPLOAD.DESCRIPTION">
        You can add up to two more photos to your item description. To do this, click on the button "Select file" and
        choose the new photo you wish to appear in the description. The new version will appear on the site once
        validated by the team, and when photos have been processsed.
      </p>
      <div class="addPictures__files">
        <vc-file-uploader
          (onFileSelected)="onFileSelected($event)"
          [acceptableExtensions]="acceptableExtensions"
        ></vc-file-uploader>
      </div>
      <div class="addPictures__footer">
        <div class="addPictures__footer__messages">
          <div *ngIf="showError" class="addPictures__footer__error"></div>
          <div class="addPictures__footer__asterisque"></div>
        </div>
        <button
          type="button"
          [disabled]="loading || files.length < 1"
          class="addPictures__footer__submit vc-btn vc-btn--primary vc-btn--large vc-btn--full vc-btn--notfull--md-up vc-btn--medium"
          (click)="sendFiles()"
          i18n="@@PRODUCT.DETAILS.UPLOAD.VALIDATION_BTN"
        >
          CONFIRM
        </button>
      </div>
    </ng-template>
  </div>
</div>
